import styled from 'styled-components'

import { Box } from '~design-system'

const AddContainer = styled(Box)`
  cursor: pointer;
`

export default AddContainer
